import styled from 'styled-components';

const BaseButton = styled.button`
  line-height: 1.5715;
  position: relative;
  display: inline-block;
  font-weight: 500;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  touch-action: manipulation;
  height: 34px;
  padding: 4px 16px;
  font-size: 14px;
  border-radius: 8px;
  color: var(--text-secondary);
  background-color: transparent;
  border-color: var(--border-color);
  outline: 0;

  &:active, &:focus {
    outline: 0;
  }

  &:hover {
    color: var(--text-primary);
    border-color: var(--border-color-hover);
    background-color: var(--bg-surface-hover);
  }
`;

export const PrimaryButtonStyled = styled(BaseButton)`
  color: #fff;
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);

  &:hover {
    color: #fff;
    background-color: var(--color-primary-hover);
    border-color: var(--color-primary-hover);
  }

  &.loader {
    color: transparent !important;
    pointer-events: none;
    position: relative;
    text-shadow: none;

    &:after {
      -webkit-animation: spinAround .5s infinite linear;
      animation: spinAround .5s infinite linear;
      border: 2px solid #dbdbdb;
      border-radius: 50%;
      content: "";
      display: block;
      height: 1em;
      width: 1em;
      position: absolute;
      left: calc(50% - (1em / 2));
      top: calc(50% - (1em / 2));
      border-color: transparent transparent #fff #fff !important;
    }
  }
`;

export const DangerButtonStyled = styled(BaseButton)`
  color: #fff;
  background-color: var(--color-danger);
  border-color: var(--color-danger);
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);

  &:hover {
    color: #fff;
    background-color: var(--color-danger-hover);
    border-color: var(--color-danger-hover);
  }

  &.loader {
    color: transparent !important;
    pointer-events: none;
    position: relative;
    text-shadow: none;

    &:after {
      -webkit-animation: spinAround .5s infinite linear;
      animation: spinAround .5s infinite linear;
      border: 2px solid #dbdbdb;
      border-radius: 50%;
      content: "";
      display: block;
      height: 1em;
      width: 1em;
      position: absolute;
      left: calc(50% - (1em / 2));
      top: calc(50% - (1em / 2));
      border-color: transparent transparent #fff #fff !important;
    }
  }
`;

export const PrimaryLinkedButtonStyled = styled(BaseButton)`
  color: var(--color-primary);
  border-color: transparent;
  background: transparent;

  &:hover {
    color: var(--color-primary-hover);
    background-color: transparent;
    border-color: transparent;
    text-decoration: underline;
  }
`;

export const GreenButtonStyled = styled(BaseButton)`
  color: #fff;
  background: var(--color-success);
  border-color: var(--color-success);
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);

  &:hover {
    color: #fff;
    background-color: var(--color-success-hover);
    border-color: var(--color-success-hover);
  }

  &.loader {
    color: transparent !important;
    pointer-events: none;
    position: relative;
    text-shadow: none;

    &:after {
      -webkit-animation: spinAround .5s infinite linear;
      animation: spinAround .5s infinite linear;
      border: 2px solid #dbdbdb;
      border-radius: 50%;
      content: "";
      display: block;
      height: 1em;
      width: 1em;
      position: absolute;
      left: calc(50% - (1em / 2));
      top: calc(50% - (1em / 2));
      border-color: transparent transparent #fff #fff !important;
    }
  }

  &.clicked {
    background: var(--color-success-hover);
  }

  &.disabled {
    background: rgba(255, 255, 255, 0.15);
    color: var(--text-muted);
    border-color: var(--border-color);
    cursor: default;
    
    &:hover {
      background: rgba(255, 255, 255, 0.15);
      color: var(--text-muted);
      border-color: var(--border-color);
    }
  }
`;